"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIHoverlay = _interopRequireDefault(require("UIComponents/overlay/UIHoverlay"));

var ImagePreview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ImagePreview, _Component);

  function ImagePreview() {
    (0, _classCallCheck2.default)(this, ImagePreview);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ImagePreview).apply(this, arguments));
  }

  (0, _createClass2.default)(ImagePreview, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onHoverlayClick = _this$props.onHoverlayClick,
          hoverlayLabel = _this$props.hoverlayLabel,
          alt = _this$props.alt,
          src = _this$props.src,
          className = _this$props.className,
          readOnly = _this$props.readOnly;
      var previewClassName = (0, _classnames.default)('image-preview', className);

      var preview = _react.default.createElement(_UIFlex.default, {
        className: previewClassName,
        align: "center",
        justify: "center"
      }, _react.default.createElement(_UIImage.default, {
        className: "image-preview__image",
        alt: alt || '',
        src: src
      }));

      if (hoverlayLabel && !readOnly) {
        var hoverlayContent = _react.default.createElement(_UIFlex.default, {
          align: "center",
          alignSelf: "center",
          direction: "column",
          justify: "center"
        }, hoverlayLabel);

        return _react.default.createElement(_UIHoverlay.default, {
          onClick: onHoverlayClick,
          foregroundContent: hoverlayContent
        }, preview);
      }

      return preview;
    }
  }]);
  return ImagePreview;
}(_react.Component);

ImagePreview.propTypes = {
  alt: _propTypes.default.string,
  src: _propTypes.default.string.isRequired,
  onHoverlayClick: _propTypes.default.func,
  hoverlayLabel: _propTypes.default.node,
  className: _propTypes.default.string,
  readOnly: _propTypes.default.bool
};
ImagePreview.defaultProps = {
  alt: '',
  onHoverlayClick: _emptyFunction.default
};
var _default = ImagePreview;
exports.default = _default;
module.exports = exports.default;